module.exports = __webpack_public_path__ + "img/order_icon_amount.5a519a92.png";